import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Done from '@material-ui/icons/Done';
import {
  Grid, Button, Typography, Grow,
} from '@material-ui/core';
import actions from 'shared/actions';
import styles from 'shared/styles';

export const testId = 'btn';

export function ResetPasswordButtonImpl({ username, onClick }) {
  const [clicked, setClicked] = React.useState(false);
  const submitText = clicked ? (
    <Grid item xs={12}>
      <Grow in={clicked} timeout={500}>
        <Typography>
          Thanks! If your username is registered with
          a PricePoint account, you&apos;ll get an email with a link to reset your password shortly.
        </Typography>
      </Grow>
    </Grid>
  ) : '';
  const btnText = clicked ? <Done /> : 'Reset Password';
  const disabled = !username || clicked;
  return (
    <>
      <Grid item xs={12}>
        <Button
          onClick={() => {
            setClicked(true);
            onClick(username);
          }}
          style={styles.submitButton}
          data-test={testId}
          disabled={disabled}
        >
          {btnText}
        </Button>
      </Grid>
      {submitText}
    </>
  );
}

ResetPasswordButtonImpl.propTypes = {
  username: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  onClick: actions.staging.onSubmitForgotPassword,
};

export default connect(null, mapDispatchToProps)(ResetPasswordButtonImpl);
